// extracted by mini-css-extract-plugin
export default {"name":"PermissionField_name__tmizs"};